<div class="wrapper">
  <div class="block-center mt-xl wd-xl ">
    <div class="text-center mt-xl mb-xl" >
      <img src="assets/img/logo_step.png" title="Step logo" class="block-center" alt="logo" />
    </div>

    <div class="panel">
      <div class="panel-body">
        <p class="text-center pv">{{ 'auth.login.2fa-desc' | translate }}</p>

        <form [formGroup]="form" class="form-validate mb-lg" role="form" name="loginForm" novalidate="" (submit)="submitForm($event, form.value)">

          <div class="form-group" [ngClass]="{ 'has-error': twoFa.invalid && twoFa.touched }">
            <input type="text" class="form-control" formControlName="twoFa" [placeholder]="'auth.login.2fa' | translate"  autocomplete="off">

            <div *ngIf="twoFa.invalid && twoFa.touched" class="text-danger">
              <small *ngIf="twoFa.errors.required ">{{ 'error.input.required' | translate }}</small>
              <small *ngIf="twoFa.errors.code_error ">{{ 'error.input.code_error' | translate }}</small>
            </div>
          </div>

          <div role="alert" class="alert alert-danger fade in" *ngIf="wrong2fa">{{ 'error.invalid2fa' | translate }}</div>

          <button class="btn btn-block btn-primary mt-lg" type="submit" [disabled]="form.invalid || sendRequest">
            <span *ngIf="sendRequest"><div class="fa fa-spinner fa-spin"></div> {{ 'common.loadingBtn' | translate }}</span>
            <span *ngIf="!sendRequest">{{ 'account.profile.validate-2fa' | translate }}</span>
          </button>
        </form>
      </div>

    </div>

    <div class="text-center" >
      <a (click)="logout()" >Uitloggen</a>
    </div>

    <div class="p-lg text-center">
      <span>&copy;</span>
      <span>{{ settings.app.year }}</span>
      <span>-</span>
      <span>{{ settings.app.name }}</span>
      <br/>
      <span>{{ settings.app.description }}</span>
    </div>
  </div>
</div>
